<template>
    <v-app>
        <app-top-bar :menu="menu" :color="'linear-gradient(135deg, #37474F 0%, #607D8B 100%)'" :moduleName="'ATTENDANCE MODULE'"/>
        <v-main>
        <router-view/>
        </v-main>
  </v-app>
</template>

<script>
import AppTopBar from '../components/AppTopAndSideBar.vue';

export default {
  components: { AppTopBar},
    name: 'AttendanceLayout',
    data: () => ({
        menu: [
            { text: 'All Modules', icon: 'mdi-view-dashboard', routerName: 'ModuleSelector' },
            { text: 'Attendance Dashboard', icon: 'mdi-view-dashboard', routerName: 'AttendanceDashboard' },
            { text: 'Students Attendance', icon: 'mdi-check', routerName: 'MarkAttendance' },
            { text: 'Students Summary', icon: 'mdi-check', routerName: 'AttendanceSummary' },
            { text: 'Manage Staff', icon: 'mdi-account-tie-outline', routerName: 'ManageStaff' },
            { text: 'Teacher Attendance', icon: 'mdi-account-check', routerName: 'TeacherClock' },
            { text: 'Teacher Summary', icon: 'mdi-account-check', routerName: 'TeacherClockSummary' },
        ],
    }),
};
</script>